module.exports = __webpack_public_path__ + "img/阻力带右腿拉伸.10e5e4d3.png";